// Shows Address Line 1/2 for a street address and Latitude/Longitude for coordinates on the EM
// "Add a location" form. The page renders the group of the type it loads with; this switches
// them. The inactive group is hidden, never disabled, so both submit and the API applies the
// checked type.
import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['addressFields', 'coordinateFields', 'locationType']

  addressFieldsTarget: HTMLElement
  coordinateFieldsTarget: HTMLElement
  locationTypeTargets: HTMLInputElement[]

  connect(): void {
    const checked = this.locationTypeTargets.find((input) => input.checked)

    if (checked != null) this.showFieldsFor(checked.value)
  }

  toggleLocationType(event: Event): void {
    this.showFieldsFor((event.target as HTMLInputElement).value)
  }

  private showFieldsFor(locationType: string): void {
    const coordinates = locationType === 'coordinates'

    this.addressFieldsTarget.classList.toggle('d-none', coordinates)
    this.coordinateFieldsTarget.classList.toggle('d-none', !coordinates)
  }
}
